// ##############################
// // // media
// #############################
var IMGDIR = process.env.REACT_APP_IMGDIR;

const media = [
    {avatar: IMGDIR+"/images/blog/media/media-1.jpg", name: "Sunny morning", by: "Mak Gill"},
    {avatar: IMGDIR+"/images/blog/media/media-2.jpg", name: "Glowing trees", by: "Emma Dyer"},
    {avatar: IMGDIR+"/images/blog/media/media-3.jpg", name: "Sunrise at beach", by: "Heather Clark"},
    {avatar: IMGDIR+"/images/blog/media/media-4.jpg", name: "Nature time", by: "Joan Glover"},
    {avatar: IMGDIR+"/images/blog/media/media-5.jpg", name: "Adventure tracks", by: "Jane Frost"},
    {avatar: IMGDIR+"/images/blog/media/media-6.jpg", name: "Beach outcast", by: "Karen Knox"},
    {avatar: IMGDIR+"/images/blog/media/media-7.jpg", name: "Wildlife", by: "Pippa Lee"},
    {avatar: IMGDIR+"/images/blog/media/media-8.jpg", name: "Tracking", by: "Ava Miller"},
]; 

export {
    media, 
};
